// extracted by mini-css-extract-plugin
module.exports = {"down-arrow":"DownArrow_down-arrow__LOHGj"};